import { useEffect } from "react";
import { Projects, Header, About, MachineLearning } from "./exports";
import { Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router";
import Stack from "./components/stack/Stack";
import DataProjects from "./components/dataprojects/DataProjects";

function App() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/data-projects");
  }, []);
  return (
    <div>
      <Header />
      <Routes>
        <Route exact path="/projects" element={<Projects />} />
        <Route exact path="/about" element={<About />} />
        <Route exact path="/technical-stack" element={<Stack />} />
        <Route exact path="/data-projects" element={<DataProjects />} />
        <Route exact path="/machine-learning" element={<MachineLearning />} />
      </Routes>
    </div>
  );
}

export default App;

var solution = function (k) {
  // write your solution here
  return -1;
};
